<template>
  <div class="p-4 bottom">
    <div class="container-fluid">
      <div class="row">
        <div class="col-12 text-center">{{ appName }} &copy; 2020 - by <a href="https://twitter.com/demircancelebi" target="_blank">@demircancelebi</a> </div>
      </div>
    </div>
  </div>
</template>

<script>
import config from '@/config';

export default {
  name: 'bottom',
  computed: {
    onGame() {
      return this.$route.path.indexOf('/games') === 0;
    },
  },
  data() {
    return {
      appName: config.appName,
    };
  },
};
</script>
